// extracted by mini-css-extract-plugin
export default {"footerDescription":"FooterDescription_footerDescription__6KDtw"};